document.addEventListener('DOMContentLoaded', () => { // intercepting theme js from opening cart-drawer for bulk-order page only
  const blockDrawerOnPath = '/pages/bulk-order'; // Change if needed

  if (window.location.pathname === blockDrawerOnPath) {
    const cartDrawer = document.querySelector('cart-drawer');

    if (!cartDrawer) return;

    // Track if we're currently submitting via product form
    let blockDrawerTemporarily = false;

    // Inject toast elements if not already present
    const toastOverlay = document.getElementById('vib-toast-overlay');

    // Attach to all product forms
    document.querySelectorAll('form.shopify-product-form').forEach(form => {
      form.addEventListener('submit', () => {
        blockDrawerTemporarily = true;

        // Reset after short delay to allow manual actions again
        setTimeout(() => {
          blockDrawerTemporarily = false;
        }, 3000);

        // Show toast
        if (toastOverlay) {
          toastOverlay.style.display = 'block';
          toastOverlay.style.opacity = '1';

          const removeToast = () => {
            toastOverlay.style.transition = 'opacity 0.3s ease';
            toastOverlay.style.opacity = '0';
            setTimeout(() => {
              toastOverlay.style.display = 'none';
            }, 300);
            document.removeEventListener('click', removeToast);
          };

          // Auto dismiss after 2 seconds
          setTimeout(removeToast, 2000);

          // Or dismiss on click
          setTimeout(() => {
            document.addEventListener('click', removeToast);
          }, 100); // small delay to prevent immediate click
        }
        
      });
    });

    // Override setAttribute ONLY during add-to-cart flow
    const originalSetAttribute = Element.prototype.setAttribute;

    Element.prototype.setAttribute = function(name, value) {
      if (
        this === cartDrawer &&
        name === 'open' &&
        blockDrawerTemporarily
      ) {
        console.log('Cart drawer open blocked after ATC');
        return;
      }

      return originalSetAttribute.apply(this, arguments);
    };
  }
});

document.addEventListener("DOMContentLoaded", function () { // ajax call on bulk-order page to append more products if any
  document.querySelectorAll(".lazy-load-button").forEach(function (btn) {
    btn.addEventListener("click", function () {
      const collectionHandle = btn.dataset.collection;
      const offset = parseInt(btn.dataset.offset);
      const limit = parseInt(btn.dataset.limit);
      const wrapper = document.querySelector("#lazy-wrapper-" + collectionHandle);

      fetch(`/collections/${collectionHandle}?view=ajax`)
        .then(response => response.text())
        .then(html => {
          // Create a temporary element to parse the HTML
          const tempEl = document.createElement("div");
          tempEl.innerHTML = html;

          const products = tempEl.querySelectorAll('.product-card'); // Adjust selector if needed
          const slicedProducts = Array.from(products).slice(offset, offset + limit);

          slicedProducts.forEach(prod => wrapper.appendChild(prod));

          // Update offset or hide button
          btn.dataset.offset = offset + limit;
          if (offset + limit >= products.length) {
            btn.remove();
          }
        });
    });
  });
});

document.addEventListener('DOMContentLoaded', function () { //auto-switching tabs in center for all tabbed sections
  const allXTabs = document.querySelectorAll('x-tabs');

  allXTabs.forEach(xTabs => {
    if (!xTabs.shadowRoot) return;

    const shadow = xTabs.shadowRoot;
    const tabButtons = shadow.querySelector('slot[name="title"]')?.assignedElements() || [];

    const tablistContainer = shadow.querySelector('.top-container-tpd');
    if (!tablistContainer) return;

    tabButtons.forEach(button => {
      button.addEventListener('click', function () {
        const containerRect = tablistContainer.getBoundingClientRect();
        const buttonRect = button.getBoundingClientRect();

        if (buttonRect.left < containerRect.left || buttonRect.right > containerRect.right) {
          const scrollAmount = button.offsetLeft - tablistContainer.offsetWidth / 2 + button.offsetWidth / 2;
          tablistContainer.scrollTo({ left: scrollAmount, behavior: 'smooth' });
        }
      });
    });
  });
});

document.querySelectorAll(".shopify-section--faq details.accordion").forEach((el, index, allAccordions) => { // close accordions automatically when the clicked one is open
    el.addEventListener("click", function (event) {
        event.preventDefault(); // Prevent default summary toggle

        // Close all other accordions
        allAccordions.forEach((item) => {
            if (item !== this) {
                item.removeAttribute("open");
                item.setAttribute("aria-expanded", "false");
            }
        });

        // Open the clicked accordion
        this.setAttribute("open", "");
        this.setAttribute("aria-expanded", "true");

    });
});

$(document).ready(function(){
  // mega_menu sub_menu selection 
  $("li.main_menu_cu").on("click", function(){
      // Reset font-family for all siblings within the same mega-menu
      const $megaMenu = $(this).closest(".mega-menu");
      
      $megaMenu.find("li.main_menu_cu a.h5 span").each(function(){
          this.style.setProperty('font-family', 'ObviouslyR', 'important');
      });

      $(this).children("a").children("span").each(function(){
          this.style.setProperty('font-family', 'ObviouslyB', 'important');
      });

      // Show only the relevant submenu within the same mega-menu
      let $child_mm = $(this).find("ul.sub_menu_cu");
      if($child_mm.length > 0){
          $megaMenu.find("ul.sub_menu_cu").hide();
          $child_mm.css('display', 'flex');
      }
  });
});

$(document).ready(function(){

  // adjusting values from - and + icons of cart
  
  // inititate main quantity changer
  attachCartEvents();

  // attach event listner for the cart change
  document.addEventListener("cart:change", function(){
     
      //console.log('kevin');
      
      setTimeout(function(){
          attachCartEvents();
      }, 2000);
  }); 

  // update cart items
  function updateCartItem( variant_id, quantity, operation){
      
      //co
      var data = { updates: {} };
      var item_count;
      //var data = [{ quantity: quantity, id: variant_id }];
      data.updates[variant_id] = quantity;
      
      $(".loading_wait").show();
      $(".loading_overlay").show();

      jQuery.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: data,
          dataType: 'json',
          success: function(result) { 
             
              $.when( 
                  jQuery.getJSON('/cart.js', function(cart) {
                      
                      item_count = cart.item_count;
                      let cartData = cart.items;
                      document.dispatchEvent(new CustomEvent('cart:build' ,{
                              bubbles: true
                          }
                      )); 
                      document.dispatchEvent(new CustomEvent('cart:refresh', {
                          bubbles: true,
                          detail: cartData
                      })); 
                  })
              ).then(function(){
                  
                  setTimeout(function(){
                      
                      // don't re-attach
                      if( window.location.pathname.indexOf('/cart/') == -1)
                          attachCartEvents();

                      $(".header__cart-count").find(".count-bubble").html(item_count);
                      $(".loading_wait").hide();
                      $(".loading_overlay").hide();
                      
                      // console.log('re-attached');
                  }, 2000);

              });
          }
      });
  }



  function justRefresh(){
      
    var data = { updates: {} };
    var item_count;
    
    $(".loading_wait").show();
    $(".loading_overlay").show();
  
    jQuery.ajax({
        type: 'GET',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function(result) { 
           
            $.when( 
                jQuery.getJSON('/cart.js', function(cart) {
                    
                    item_count = cart.item_count;
                    let cartData = cart.items;
                    document.dispatchEvent(new CustomEvent('cart:build' ,{
                            bubbles: true
                        }
                    )); 
                    document.dispatchEvent(new CustomEvent('cart:refresh', {
                        bubbles: true,
                        detail: cartData
                    })); 
                })
            ).then(function(){
                
                setTimeout(function(){
                    
                    // don't re-attach
                    if( window.location.pathname.indexOf('/cart/') == -1)
                        attachCartEvents();
  
                    $(".loading_wait").hide();
                    $(".loading_overlay").hide();
                    
                    // console.log('re-attached');
                }, 2000);
  
            });
  
            // console.log(result);
        }
    });
  }

  // main function for event attaching event listners
  function attachCartEvents(){
      $(".i_minus_cart").click(function(){
          //console.log("MINUS");
          
          var minus;
          
          let $inputBox = $(this).parents('.line_changer').find('input.quantity-input');

          minus = parseInt( $inputBox.attr('value') ) - 1;
          
          $inputBox.attr('value', minus);
          
          //console.log($inputBox.attr('value'));
          //console.log(minus);
          //$(this).parents('.line-item').find('.line_item_hdn').find('input.quantity-input').attr('value', minus);
  
          var variant_id = $(this).parents('.line_changer').attr("line_var_id");
        
          updateCartItem(variant_id, minus, 'minus'); 
  
      });
      
      $(".i_plus_cart").click(function(){
          //console.log('PLUS')
          
          var plus, max, currrent_qty;
          let $inputBox = $(this).parents('.line_changer').find('input.quantity-input');
          
          currrent_qty = parseInt( $inputBox.attr('value') );
          plus = currrent_qty + 1;
              
          $inputBox.attr('value', plus);

          //console.log(currrent_qty);
          //console.log(plus);
          //$(this).parents('.line-item').find('.line_item_hdn').find('input.quantity-input').attr('value', plus);

          var variant_id = $(this).parents('.line_changer').attr("line_var_id");
          updateCartItem(variant_id, plus, 'plus'); 
  
      });
    
      $("#nector-useyourcoins-container").click(function(){
          // justRefresh(); 
      });
    
  }
  
});





